/*
Notes:预留，公共Api接口
PS：
Date:2018/9/3 by Hgwn
*/
import ajax from './ajax';

export default {
    getSubNav:function(params){ //获取用户看板数据
        return ajax.postForm('loanform/base/loanBaseProductCategory/getCategoryList.ht');
    }
};



// WEBPACK FOOTER //
// ./src/api/home.js